<div class="table-settings-wrapper bg-background-primary">
  <div class="w-1/3 border-right hidden md:flex flex-col py-4 px-3 overflow-auto" *ngIf="data.tableSettings.length > 1">
    <div class="font-medium fs-11 mb-3">
      <img width="15" src="{{ data.activeDatasourceSettings.typeModel.logo }}" class="mr-2" alt="" />{{
        data.activeDatasourceSettings.name
      }}
    </div>
    <div *ngFor="let tableItem of data.tableSettings; let i = index; trackBy: trackByKey" class="table-design-wrapper">
      <button
        mat-button
        class="table-design truncate"
        (click)="scrollTo(tableItem[0])"
        [intercomTarget]="'01-table-settings-53572' + tableItem[0]"
        [class.active]="activeTableSettingsId === tableItem[0]"
      >
        <y42-feature-type-child-icon
          [featureType]="Y42FeatureType.Integration"
          [customClasses]="['mat-tooltip-trigger']"
        ></y42-feature-type-child-icon>
        {{ tableItem[0] }}
      </button>
      <y42-sub-navigation
        *ngIf="formTables.controls[i].controls.csv_options"
        (navigationClicked)="scrollTo(tableItem[0], TableSettingsCsvOptionsPropertyName)"
        [navigationType]="tableSettingsNavigationsConstant[TableSettingsCsvOptionsPropertyName]"
      >
      </y42-sub-navigation>
      <y42-sub-navigation
        *ngIf="formTables.controls[i].controls._datos_write_settings"
        (navigationClicked)="scrollTo(tableItem[0], TableSettingsWriteSettingsPropertyName)"
        [navigationType]="tableSettingsNavigationsConstant[TableSettingsWriteSettingsPropertyName]"
      >
      </y42-sub-navigation>
    </div>
  </div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div formArrayName="tables">
      <div
        id="parentDiv"
        class="table-settings-right-side"
        y42ScrollSpy
        [spiedTags]="['DIV']"
        (sectionChange)="onSectionChange($event)"
      >
        <div
          id="{{ tableItem[0] }}"
          class="form-section"
          *ngFor="let tableItem of data.tableSettings; let i = index; trackBy: trackByKey"
          [formGroupName]="i"
        >
          <div class="table-title-display aligner-start">
            <div class="helper-div"></div>
            <y42-feature-type-child-icon
              [featureType]="Y42FeatureType.Integration"
              [customClasses]="['mat-tooltip-trigger']"
            ></y42-feature-type-child-icon>
            {{ tableItem[0] }}
          </div>
          <div class="w-full" id="{{ tableItem[0] + TableSettingsCsvOptionsPropertyName }}">
            <y42-csv-settings
              *ngIf="formTables.controls[i].controls.csv_options"
              [form]="formTables.controls[i].controls.csv_options!"
            >
            </y42-csv-settings>
          </div>
          <div class="w-full" id="{{ tableItem[0] + TableSettingsWriteSettingsPropertyName }}">
            <y42-write-settings
              *ngIf="formTables.controls[i].controls._datos_write_settings"
              [form]="formTables.controls[i].controls._datos_write_settings!"
            >
            </y42-write-settings>
          </div>
        </div>
      </div>
      <div class="flex action-bar px-4 pt-3 z-depth-1">
        <div class="pr-1 pb-3 grow">
          <button
            mat-raised-button
            class="cancel-button"
            type="button"
            (click)="onNoClick()"
            [attr.data-test]="'datasource-table-settings-dialog-button-cancel'"
          >
            Cancel
          </button>
        </div>
        <div class="pl-1 pb-3 grow">
          <button
            mat-raised-button
            class="confirm-button"
            color="primary"
            type="submit"
            [disabled]="form.invalid"
            [attr.data-test]="'datasource-table-settings-dialog-button-apply'"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
